import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';
import dayjs, { Dayjs } from 'dayjs';
import {
  DashboardListItem as EDashboardListItem,
  PermissionOperation,
  PermissionResource,
  TenantState,
  UserInterests,
  UserRole,
  UserState,
} from 'generated/graphql';
import { DashboardListItem } from 'v2/core/entities/dashboard';
import { Integration } from 'v2/core/entities/integrations';
import { UUID } from 'v2/core/entities/uuid';

export enum UserType {
  SuperManager = 'SUPER_MANAGER',
  SuperAdmin = 'SUPER_ADMIN', // TODO: deprecate, and replace with SUPER_EDITOR
  SuperViewer = 'SUPER_VIEWER',
  Manager = 'MANAGER',
  Admin = 'ADMIN', // TODO: deprecate, and replace with EDITOR
  Viewer = 'VIEWER',
  SuperEditor = 'SUPER_EDITOR',
  Editor = 'EDITOR',
  Unknown = 'UNKNOWN',
  Member = 'MEMBER',
  SuperMember = 'SUPER_MEMBER',
}
export type Tenant = {
  id: UUID;
  name: string;
  tier: TenantTier;
  slug?: string;
  avatarURL?: string;
  domains?: Array<string>;
  state: TenantState;
  timezone: string;
  dashboardSettings: TenantDashboardSettings;
  pinnedDashboards: DashboardListItem[];
};

export type TenantDashboardSettings = {
  homePageStatsDashboard?: UUID;
  showUnTranslatedRecords?: boolean;
  startDate: dayjs.Dayjs;
  defaultTimeRange?: DateTimeRange;
  defaultUserType?: UserType;
  homepageDashboardID?: UUID;
};

export interface AnomalySettings {
  homePageRuleIDs?: UUID[];
}

export type User = {
  id: UUID;
  email: string;
  firstName: string;
  lastName: string;
  role?: UserRole;
  type: UserType;
  tenant: Tenant;
  defaultTenant: Tenant;
  createdAt: Dayjs;
  notificationChannels?: Integration[];
  interests?: {
    keywords: UserInterests['keywords'];
    labelIDs: UserInterests['labelIDs'];
  };
  pinnedDashboards?: EDashboardListItem[];
  state?: UserState;
  permissions?: UserPermissionType[];
  intercomUserHash?: string;
  homepageDashboardID?: UUID;
};

export type BaseUser = Omit<User, 'tenant' | 'defaultTenant'>;

export enum TenantTier {
  Basic = 'BASIC',
  Premium = 'PREMIUM',
  Freemium = 'FREEMIUM',
}

export interface UserPermissionType {
  resource: PermissionResourceType;
  operation: PermissionOperation;
}

export enum SuperPermissionResource {
  TenantSwitch = 'TENANT_SWITCH',
  Discoverability = 'DISCOVERABILITY',
}

export type PermissionResourceType =
  | PermissionResource
  | SuperPermissionResource;

export type Timezone = string;
